import Model from 'src/app/common/model';
import DeviceModel from 'src/app/services/device.model';

export default class DeviceMovementModel extends Model {
  device: DeviceModel;
  action_name: string;
  from_loc: number;
  to_loc: number;
  from_id?: string;
  to_id?: string;
  from: string;
  to: string;
  device_id: string;
  date?: Date | string;
  time?: Date | string;
  comment?: string;
  created_by: string;
  updated_by: string;
  business_id: string;
  serial_number: string;
  provider_id: string;
  businessTypeID: string;
  isContinuousMonitoring: number;

  constructor() {
    super();
  }
}
